import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { App as CapacitorApp } from '@capacitor/app';

export const BackButtonHandler = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const handleBackButton = () => {
            if (window.location.pathname === '/') {
                CapacitorApp.exitApp();
            } else {
                navigate(-1);
            }
        };

        let backButtonListener: any;

        (async () => {
            backButtonListener = await CapacitorApp.addListener('backButton', handleBackButton);
        })();

        return () => {
            if (backButtonListener) {
                backButtonListener.remove();
            }
        };
    }, [navigate]);

    return null;
};